module.exports = __webpack_public_path__ + "static/media/Profile.e6f4fe3d.svg";